import { Typography, TypographyProps, useTheme } from '@mui/material';
import { Link } from '@mui/material';
import { useMemo } from 'react';

import * as prod from 'react/jsx-runtime'
import rehypeParse from 'rehype-parse'
import rehypeReact from 'rehype-react'
import { unified } from 'unified';

// @ts-expect-error: the react types are missing.
const production = {Fragment: prod.Fragment, jsx: prod.jsx, jsxs: prod.jsxs, components: {'a': Link}}


function useProcessor(text: string) {
  return unified()
  .use(rehypeParse, {fragment: true})
  // @ts-ignore
  .use(rehypeReact, production)
  .processSync(text).result
}

export interface TextProps extends TypographyProps {
  content: string;
  anchor?: string;
}
const Text = ({ content, anchor: id, ...props }: TextProps) => {
  const theme = useTheme();
  const children = useProcessor(content)

  const marginTop = useMemo(() => {
    switch (props.variant) {
      case 'h1':
        return theme.spacing(6);
      case 'h2':
        return theme.spacing(5);
      case 'h3':
        return theme.spacing(4);
      case 'h4':
        return theme.spacing(3);
      case 'h5':
        return theme.spacing(2);
      case 'h6':
        return theme.spacing(1);
    }
  }, [props.variant]);

  return (
    <Typography
      sx={{
        width: theme.spacing(120),
        maxWidth: `calc(100vw - ${theme.spacing(4)})`,
        marginBottom: theme.spacing(2),
        marginTop
      }}
      {...props}
      id={id}
    >
      {children}
    </Typography>
  );
};
Text.strapiComponent = '';

const Heading: typeof Text = (props) => <Text {...props} />;
Heading.strapiComponent = 'maastr.heading';

const Paragraph: typeof Text = (props) => <Text {...props} />;
Paragraph.strapiComponent = 'maastr.paragraph';

export { Heading, Paragraph };
